class HeroSlideshow {
  constructor(el) {
    this.el = el;
    this.slides = Array.from(el.querySelectorAll('.hero-slideshow__slide'));
    this.dots = Array.from(el.querySelectorAll('.hero-slideshow__dot'));
    this.current = 0;
    this.autoplay = el.dataset.autoplay === 'true';
    this.autoplaySpeed = parseInt(el.dataset.autoplaySpeed, 10) || 5000;
    this.timer = null;

    if (this.slides.length <= 1) return;

    this.dots.forEach((dot, index) => {
      dot.addEventListener('click', () => this.go(index));
    });

    el.addEventListener('mouseenter', () => this.stop());
    el.addEventListener('mouseleave', () => this.start());
    el.addEventListener('focusin', () => this.stop());
    el.addEventListener('focusout', () => this.start());

    this.setupSwipe();
    this.start();
  }

  go(index) {
    const total = this.slides.length;
    this.current = (index + total) % total;

    this.slides.forEach((slide, i) => {
      slide.classList.toggle('is-active', i === this.current);
    });
    this.dots.forEach((dot, i) => {
      dot.classList.toggle('is-active', i === this.current);
    });
  }

  start() {
    if (!this.autoplay || this.slides.length <= 1) return;
    this.stop();
    this.timer = setInterval(() => this.go(this.current + 1), this.autoplaySpeed);
  }

  stop() {
    if (this.timer) {
      clearInterval(this.timer);
      this.timer = null;
    }
  }

  setupSwipe() {
    let startX = 0;
    const track = this.el.querySelector('.hero-slideshow__track');
    if (!track) return;

    track.addEventListener('touchstart', (e) => {
      startX = e.touches[0].clientX;
    }, { passive: true });

    track.addEventListener('touchend', (e) => {
      const endX = e.changedTouches[0].clientX;
      const diff = startX - endX;
      if (Math.abs(diff) > 40) {
        this.go(diff > 0 ? this.current + 1 : this.current - 1);
      }
    }, { passive: true });
  }
}

function initHeroSlideshow(el) {
  if (el && !el.heroSlideshowInstance) {
    el.heroSlideshowInstance = new HeroSlideshow(el);
  }
}

document.querySelectorAll('.hero-slideshow').forEach(initHeroSlideshow);

document.addEventListener('shopify:section:load', (event) => {
  initHeroSlideshow(event.target.querySelector('.hero-slideshow'));
});

document.addEventListener('shopify:section:select', (event) => {
  const el = event.target.querySelector('.hero-slideshow');
  if (el && el.heroSlideshowInstance) el.heroSlideshowInstance.stop();
});

document.addEventListener('shopify:block:select', (event) => {
  const wrapper = event.target.closest('.hero-slideshow');
  if (!wrapper || !wrapper.heroSlideshowInstance) return;
  const slide = event.target.closest('.hero-slideshow__slide');
  if (slide) {
    const index = parseInt(slide.dataset.slideIndex, 10);
    wrapper.heroSlideshowInstance.stop();
    wrapper.heroSlideshowInstance.go(index);
  }
});

document.addEventListener('shopify:block:deselect', (event) => {
  const wrapper = event.target.closest('.hero-slideshow');
  if (wrapper && wrapper.heroSlideshowInstance) wrapper.heroSlideshowInstance.start();
});